module.exports = __webpack_public_path__ + "img/1.5b97f74b.png";